import { useState } from 'react'
import { lenderLogoUrl } from '../utils/lenderLogo'

interface Props {
  name: string
  /** Height in px for the logo image / chip. Default 28. */
  size?: number
}

/**
 * A lender's logo, resolved from a logo CDN. If the logo is missing/blocked or
 * the CDN is unavailable, falls back to a clean text chip so it never looks
 * broken. The fallback is also what shows if we haven't mapped the lender's
 * domain yet.
 */
export default function LenderLogo({ name, size = 28 }: Props) {
  const url = lenderLogoUrl(name)
  const [failed, setFailed] = useState(!url)

  if (failed) {
    return (
      <span
        className="inline-flex items-center px-3 rounded-md bg-[#F4F4F0] text-ink font-heading font-semibold whitespace-nowrap"
        style={{ height: size, fontSize: Math.max(11, size * 0.42) }}
        title={name}
      >
        {name}
      </span>
    )
  }

  return (
    <img
      src={url}
      alt={name}
      title={name}
      loading="lazy"
      onError={() => setFailed(true)}
      style={{ height: size, maxWidth: size * 5 }}
      className="w-auto object-contain"
    />
  )
}
